module.exports = __webpack_public_path__ + "img/paket-3.5269e4fb.png";